import { useQuery } from "react-query";
import { getRequiresMaintenance } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useGetRequiresMaintenance = () => {
  const { data, isLoading, refetch } = useQuery(
    "GetRequiresMaintenance",
    getRequiresMaintenance,
    {
      refetchOnWindowFocus: false,
    }
  );

  return { data, isLoading, refetch };
};
